import { useMemo } from "react";
import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

interface IrrigationRequirementProps {
  totalWaterSupplyHectare: number;
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
  chartYears: string[];
}

const IrrigationRequirement = ({
  totalWaterSupplyHectare,
  croppingSuitabilityReports,
  chartYears,
}: IrrigationRequirementProps) => {
  const chartData = useMemo(
    () =>
      chartYears?.map((year, index) => ({
        name: year,
        value:
          croppingSuitabilityReports[0]?.annuallyNetIrrigationRequirement[index]
            ?.value,
      })),
    [chartYears, croppingSuitabilityReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={9}>
      <div className="w-full flex flex-col gap-6">
        <Title>نیاز خالص آبیاری 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-8">
          <ColumnChart
            data={chartData}
            height={350}
            titleFontSize="12px"
            color="#87CEEB"
            labelsFontSize="10px"
            yAxisTitle={"نیاز خالص آبیاری (مترمکعب در هکتار)"}
            decimalNumber={0}
            extraSeries={{
              type: "column",
              name: "مقدار",
              data: chartData?.map((_, dIdx) =>
                dIdx < chartData.length - 1 ? 0 : totalWaterSupplyHectare
              ),
              color: "orange",
              showInLegend: false,
            }}
          />
          <Title>
            مقدار نیاز خالص آبیاری برای رسیدن به پتانسیل عملکرد در 30 سال گذشته
          </Title>
        </div>
      </div>

      <NoteBox>
        نیاز خالص آبیاری محصول برای دستیابی به پتانسیل عملکرد در منطقه تخمین زده
        شده است. در نظر داشته باشید که در صورت بهبود راندمان سیستم آبیاری، میزان
        تلفات و نیاز خالص آبیاری کاهش خواهد یافت.{" "}
      </NoteBox>
    </ReportTemplate>
  );
};

export default IrrigationRequirement;
